import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GraphService } from 'src/app/services/api/graph.service';
import {
  EditAmountResult,
  EditServiceAmountInput,
  EditTicketAmountInput
} from '../model/edit-amount.model';
import {
  EDIT_SERVICE_AMOUNT_MUTATION,
  EDIT_TICKET_AMOUNT_MUTATION
} from './edit-amount.mutations';

@Injectable({ providedIn: 'root' })
export class EditAmountService {
  constructor(private readonly graph: GraphService) {}

  editServiceAmount(
    input: EditServiceAmountInput
  ): Observable<EditAmountResult> {
    return this.graph
      .mutateGraphQLCore<{ editServiceAmount: EditAmountResult }>({
        mutation: EDIT_SERVICE_AMOUNT_MUTATION,
        variables: { input }
      })
      .pipe(map((data: any) => data?.editServiceAmount as EditAmountResult));
  }

  editTicketAmount(input: EditTicketAmountInput): Observable<EditAmountResult> {
    return this.graph
      .mutateGraphQLCore<{ editTicketAmount: EditAmountResult }>({
        mutation: EDIT_TICKET_AMOUNT_MUTATION,
        variables: { input }
      })
      .pipe(map((data: any) => data?.editTicketAmount as EditAmountResult));
  }
}
